{
  "nav_zuerich": "Zürich",
  "nav_rapperswil": "Rapperswil & Zürichsee",
  "nav_einsiedeln": "Einsiedeln & Ybrig",
  "l_opening_hours": "Heures d'ouverture",
  "l_contact": "Contact",
  "l_prices": "Prix",
  "Monday": "Lundi",
  "Tuesday": "Mardi",
  "Wednesday": "Mercredi",
  "Thursday": "Jeudi",
  "Friday": "Vendredi",
  "Saturday": "Samedi",
  "Sunday": "Dimanche",
  "l_address": "Adresse",
  "l_email": "Email",
  "l_telephone": "Téléphone",
  "l_homepage": "Page d'accueil",
  "l_place": "Lieu",
  "l_route": "Itinéraire",
  "l_change_map_style": "Changer le style de la carte",
  "l_filter_categories": "Filtrer les catégories",
  "l_to_overview": "Aller à la vue d'ensemble",
  "txt_intro_h": "Découvrez, mangez, buvez, dormez, fêtez et détendez-vous à Zurich et ses environs",
  "txt_intro_1": "Découvrez Zurich et ses environs sous un nouveau jour ! Que vous soyez local ou touriste, vous trouverez ici des informations utiles sur où manger, boire, dormir, faire la fête et vous détendre. Plongez dans la diversité de notre région.",
  "txt_intro_2_zuerich": "Zurich, la métropole économique et culturelle de la Suisse, offre un mélange unique de tradition et de modernité. Découvrez les charmantes ruelles de la vieille ville, la Bahnhofstrasse animée, le lac de Zurich et les nombreux musées et théâtres.",
  "txt_intro_2_rapperswil": "Rapperswil, sur le lac de Zurich, est une ville pittoresque avec une vieille ville historique, un beau château et un impressionnant jardin de roses. De là, vous pouvez explorer le lac de Zurich, admirer les montagnes environnantes et profiter du calme de la nature.",
  "txt_intro_2_eyz": "Einsiedeln est un célèbre lieu de pèlerinage avec un impressionnant complexe monastique. Ybrig est une région avec de nombreux sentiers de randonnée et des possibilités de sports d'hiver. Ici, vous trouverez la paix et la détente au milieu des impressionnantes Alpes suisses."
}